import React, { type Dispatch, type SetStateAction } from "react";
import { useSelector } from "react-redux";

import { getEtsyIntegrations } from "src/store/plaidIntegration/selector";

import type { DialogState } from "../types";
import PlatformIntegrationsTableRow from "../PlatformIntegrationsTableRow";

import EtsyIntegrationTableRow from "./Row";

interface EtsyProps {
  hideInventory: boolean;
  setDialog: Dispatch<SetStateAction<DialogState>>;
}

function Etsy({ setDialog, hideInventory }: EtsyProps) {
  const etsyIntegrations = useSelector(getEtsyIntegrations);

  const handleEtsyAdd = async () => {
    setDialog({ type: "etsy-add" });
  };

  if (etsyIntegrations.length === 0)
    return (
      <PlatformIntegrationsTableRow
        name="Etsy"
        platform="Etsy"
        isRunning={false}
        sync={false}
        inventory={false}
        onImport={handleEtsyAdd}
        hideInventory={hideInventory}
        onPullDataNow={async () => handleEtsyAdd()}
        onSyncChanged={handleEtsyAdd}
        onAdd={handleEtsyAdd}
      />
    );
  return (
    <>
      {etsyIntegrations.map((integration) => (
        <EtsyIntegrationTableRow
          key={integration.id}
          integration={integration}
          hideInventory={hideInventory}
          setDialog={setDialog}
        />
      ))}
    </>
  );
}

export default Etsy;
